<div class="dialog">
    <div class="dialog-header">
        <h3 *ngIf="data.side !== 'buyer'">{{ 'SALES_DOCUMENT|Sprzedający:' | translate }}</h3>
        <h3 *ngIf="data.side === 'buyer'">{{ 'SALES_DOCUMENT|Kupujący:' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2">

            <h1 class="w-100" >{{ 'SALES_DOCUMENT|Dane kontrahenta:' | translate }}</h1>

            <div class="w-100" >

                <div
                    *ngIf="data.seller?.name"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma:' | translate }}</span>
                    <span class="w-70 text-left pl-1"> {{ data.seller?.name }} </span>
                </div>
                <div
                    *ngIf="data.seller?.vatNr"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Nip:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.seller.vatNr }}</span>
                </div>
                <div
                    *ngIf="data.seller?.vatNrEu"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|VAT-EU:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.seller.vatNrEu }}</span>
                </div>
                <div
                    *ngIf="data.seller?.email"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail kontaktowy:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.seller.email }}</span>
                </div>
                <div
                    *ngIf="data.seller?.phone"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon kontaktowy:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.seller.phone }}</span>
                </div>
            </div>

        </div>

        <form>

            <div
                class="w-100"
            >

                <label iccLabel > {{ 'COMPANY|Oddział' | translate }} </label>
                <icc-select
                    name="seller-resource"
                    [ngModel]="sellerResourceId" (ngModelChange)="changeSellerResource($event)"
                    [disabled]="!canResourceChange()"
                >
                    <option
                        *ngFor="let department of (data?.resources || [])"
                        [value]="department.id"
                    >
                        {{ department.name }}
                    </option>
                </icc-select>

            </div>

            <div
                class="w-100"
            >

                <label iccLabel > {{ 'COMPANY|Osoba kontaktowa' | translate }} </label>
                <icc-select
                    name="seller-worker"
                    [ngModel]="sellerWorkerId" (ngModelChange)="changeSellerWorker($event)"
                    [disabled]="!data.canQuotesSellerChange"
                >
                    <option *ngFor="let worker of (workers || [])"
                        [value]="worker.id"
                    >
                        {{ worker?.person?.reference_name }}
                    </option>
                </icc-select>

            </div>

            <div class="w-100" *ngIf="data.side === 'buyer'">

                <h4>{{ 'CONTACT|Adres dostawy:' | translate }}</h4>
                <icc-select
                    name="delivery-address"
                    [value]="deliveryAddressId"
                    (valueChange)="setDeliveryAddress($event)"
                >
                    <option
                        *ngFor="let address of (resourceDeliveryAddresses || [])"
                        [value]="address.id"
                    >
                        {{ address.addressLine1 }}, {{ address.addressLine2 }}, {{ address.postalCode }}, {{ address.city }}, {{ address.countryId }}
                    </option>
                </icc-select>

            </div>

        </form>



    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

            <div class="flex-horizontal right">

                <button
                    iccButton
                    (click)="save()"
                    appearance="primary"
                >
                    {{ 'INTERFACE|Zapisz' | translate}}
                </button>

            </div>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
